/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */

/**
 * isInputCorrect
 * @param {*} modelId
 * @param {*} result
 * @param {*} position
 * @param {*} hydraulicUnitModel
 */
export const isInputCorrect = (modelId, result, position) => {
  if (result === "-") {
    return result;
  } else {
    const finalResult = parseFloat(result);

    switch (modelId) {
      case "1-7":
        return finalResult <= 4;
      case "2-1":
        switch (position) {
          case 5:
          case 6:
            return finalResult <= 2;
          default:
            return true;
        }
      case "2-5":
        if (position > 0) {
          return finalResult >= 218.5 && finalResult <= 264.5;
        }
        return true;
      case "3-2":
        return finalResult >= 1;
      case "3-5":
        return finalResult >= 13 && finalResult <= 15;
      case "3-6":
        return finalResult > 2;
      case "3-8":
        return finalResult > 1;
      case "3-9":
        return finalResult >= 0.2 && finalResult <= 0.35;
      case "3-13":
        switch (position) {
          case 1:
            return finalResult >= 855 && finalResult <= 945;
          default:
            return finalResult >= -945 && finalResult <= -855;
        }
      case "4-4":
        switch (position) {
          case 2:
            return finalResult >= 1;
          default:
            return true;
        }
      case "4-8":
        switch (position) {
          case 0:
          case 1:
            return (
              (finalResult >= 0 && finalResult <= 29.9) ||
              (finalResult >= 330.1 && finalResult <= 360.1)
            );
          case 2:
          case 3:
            return finalResult >= 60.1 && finalResult <= 119.9;
          case 4:
          case 5:
            return finalResult >= 150.1 && finalResult <= 209.9;
          case 6:
          case 7:
            return finalResult >= 240.1 && finalResult <= 299.9;
          default:
            return true;
        }
      case "4-10":
        switch (position) {
          case 3:
            return finalResult >= 207 && finalResult <= 253;
          default:
            return true;
        }
      case "5-13":
        switch (position) {
          case 3:
            return finalResult < 1;
          default:
            return true;
        }
      case "6-6":
        switch (position) {
          case 5:
          case 7:
            return finalResult >= 0.1 && finalResult <= 0.25;
          case 6:
          case 8:
            return finalResult >= 10 && finalResult <= 50;
          case 9:
          case 10:
            return finalResult >= 50 && finalResult <= 55;
          default:
            return true;
        }
      case "7-1":
        switch (position) {
          case 2:
            return finalResult >= 1;
          default:
            return true;
        }
      case "7-3":
        switch (position) {
          case 3:
            return finalResult <= 1;
          case 5:
          case 7:
            return finalResult >= 13 && finalResult <= 15;
          case 8:
            return finalResult >= 0 && finalResult <= 10;
          case 12:
            return finalResult >= 16 && finalResult <= 17;
          default:
            return true;
        }
      case "7-4":
        switch (position) {
          case 1:
            return finalResult >= 8 && finalResult <= 10;
          case 3:
            return finalResult >= 2.8 && finalResult <= 3.5;
          default:
            return true;
        }
      case "8-5":
        return finalResult >= -7 && finalResult <= -1;
      case "8-7":
      case "8-8":
      case "8-9":
        if (position <= 11) {
          return finalResult >= 0.4 && finalResult <= 0.5;
        }
        return true;
      case "8-10":
        return finalResult > 1;
      case "8-16":
        return finalResult < 7;
      case "8-18":
        switch (position) {
          case 6:
          case 8:
          case 10:
            return finalResult >= -15 && finalResult <= -5;
          default:
            return finalResult >= 85 && finalResult <= 93;
        }
      case "8-19":
        return finalResult >= 7 && finalResult <= 13;
      case "9-2":
        return finalResult > 260;
      case "10-2":
        if (position > 0) {
          return finalResult > 2;
        }
        return true;
      case "10-6":
        if (position >= 4 && position <= 6) {
          return finalResult > 50;
        }
        return true;
      case "10-7":
        return finalResult < 200;
      case "12-4":
        return finalResult > 1;
      case "13-2":
        if (position >= 3 && position <= 8) {
          return finalResult > 0.4;
        }
        return true;
      default:
        return true;
    }
  }
};

export default isInputCorrect;
